// extracted by mini-css-extract-plugin
export default {"reports-tab-wrapper":"reports-tab_reports-tab-wrapper__ofLxP","notification-wrapper":"reports-tab_notification-wrapper__huQK6"};